import { useNavigate } from "react-router-dom";
import Restaurant from "../../../assets/icons/reataurants.svg";
import Store from "../../../assets/icons/stores.svg";
import Supermarket from "../../../assets/icons/supermarkets.svg";

const RestaurantList = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-4 pr-10">
      <div
        className="flex gap-3 items-center cursor-pointer"
        onClick={() => navigate("/restaurant")}
      >
        <div className="rounded-[4px] bg-blue/10 w-10 h-10 p-2  flex items-center justify-center">
          <img src={Restaurant} alt="" className="w-full" />
        </div>
        <div className="">Restaurants</div>
      </div>
      <div
        className="flex gap-3 items-center cursor-pointer"
        onClick={() => navigate("/supermarket")}
      >
        <div className="rounded-[4px] bg-blue/10 w-10 h-10 p-2  flex items-center justify-center">
          <img src={Supermarket} alt="" className="w-full" />
        </div>
        <div className="">Supermarkets</div>
      </div>{" "}
      <div
        className="flex gap-3 items-center cursor-pointer"
        onClick={() => navigate("/store")}
      >
        <div className="rounded-[4px] bg-blue/10 w-10 h-10 p-2  flex items-center justify-center">
          <img src={Store} alt="" className="w-full" />
        </div>
        <div className="">Stores</div>
      </div>
    </div>
  );
};

export default RestaurantList;
